import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import ChevronRight from '../assets/icons/feather/Chevron right.svg?react';

export function ChevronRightIcon(props: SvgIconProps) {
  return <SvgIcon component={ChevronRight} inheritViewBox {...props} />;
}
